/**
 * Shared presentation helpers for the supplier Performance tab.
 *
 * Extracted under CR-5563 so PerformanceTab and PerformanceBreakdownCards use
 * one copy, rather than the cards file re-declaring them after the split.
 */
import { ExternalLink } from 'lucide-react';

export function formatNumber(value: number | string | undefined | null, decimals = 0): string {
  if (value === undefined || value === null) return '-';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '-';
  return num.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

interface StatRowProps {
  label: string;
  value: string;
  suffix?: string;
  onClick?: () => void;
}

export function StatRow({ label, value, suffix, onClick }: StatRowProps) {
  const isClickable = !!onClick;
  return (
    <div
      className={`flex items-center justify-between py-1.5 ${isClickable ? 'cursor-pointer hover:bg-accent/50 -mx-2 px-2 rounded transition-colors group' : ''}`}
      onClick={onClick}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={isClickable ? (e) => (e.key === 'Enter' || e.key === ' ') && onClick?.() : undefined}
    >
      <span className="text-xs text-muted-foreground">{label}</span>
      <span className={`text-sm font-semibold flex items-center gap-1 ${isClickable ? 'text-primary group-hover:underline' : ''}`}>
        {value}{suffix || ''}
        {isClickable && <ExternalLink className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" />}
      </span>
    </div>
  );
}
